import { TreeLampScene } from './tree_lamp_scene';

const initialize = () => {

    const treeLampScene = new TreeLampScene();
    treeLampScene.render();
}

document.addEventListener('DOMContentLoaded', initialize);
